'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    backgroundColor: _colors2.default.white,
    boxSizing: 'border-box',
    margin: '0',
    paddingLeft: '0'
  },
  listHeader: {
    padding: '8px 8px 8px 16px',
    margin: '0',
    fontSize: '16px',
    fontWeight: 'bolder',
    color: _colors2.default.secondaryText
  },
  list: {
    height: '100%',
    paddingLeft: '0',
    overflowY: 'scroll',
    margin: '0'
  },
  virtualizedList: {
    outline: 'none'
  }
};
module.exports = exports.default;